import usePostJson from './usePostJson.js';
import { work_queue_claim_path, work_queue_release_path } from '~/routes';

// Claim and release actions of queue items. Calls onDone after a successful action
export default function useWorkQueueItemActions(workQueueId, onDone) {
  const { post, saving, errors } = usePostJson();

  const run = async (path, body) => {
    const result = await post(path, body);
    if (result) onDone();
    return result;
  };

  return {
    saving,
    errors,
    claim: (itemId) => run(work_queue_claim_path({ id: workQueueId, item_id: itemId, _options: true })),
    release: (itemId) => run(work_queue_release_path({ id: workQueueId, item_id: itemId, _options: true })),
  };
}
